const lazy = path => () => import(`./${path}`);

// 发薪管理
export default [
  // 日结审核详情
  {
    path: '/dailyPay/audit/changeValidWorkHour/:id',
    name: 'dailyPayChangeValidWorkHour',
    component: lazy('audit/changeValidWorkHour'),
    meta: {
      title: '调整有效工时',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/dailyPay/audit/attendanceDetail/:id',
    name: 'dailyPayAuditAttendanceDetail',
    component: lazy('audit/attendanceDetail'),
    meta: {
      title: '打卡审核详情',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/dailyPay/audit/salaryDetail/:id',
    name: 'dailyPayAuditSalaryDetail',
    component: lazy('audit/salaryDetail'),
    meta: {
      title: '发薪审核详情',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/dailyPay/audit/addRemark',
    name: 'DailyPayAuditAddRemark',
    component: lazy('audit/addRemark'),
    meta: {
      title: '添加说明',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/dailyPay/employee/detail',
    name: 'DailyPayEmployeeDetail',
    component: lazy('employee/detail'),
    meta: {
      title: '日结员工详情',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/dailyPay/employee/detail/:id',
    name: 'DailyPayEmployeeDetail',
    component: lazy('employee/detail'),
    meta: {
      title: '日结员工详情',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/dailyPay/attendance',
    name: 'Attendance',
    component: lazy('attendance/index'),
    meta: {
      title: '员工考勤详情',
      keepAlive: false
    }
  },

  // -----------风控相关------------ //
  {
    path: '/dailyPay/risk/overview',
    component: lazy('risk/overview'),
    meta: {
      title: '全部用工企业风险概况',
      keepAlive: true,
    }
  },
  {
    path: '/dailyPay/risk/factoryOverview',
    component: lazy('risk/factoryOverview'),
    meta: {
      title: '用工企业风险详情',
      keepAlive: true,
    }
  },
  {
    path: '/dailyPay/risk/audit',
    component: lazy('risk/audit'),
    meta: {
      title: '风险审核详情',
      keepAlive: true,
    }
  },
  {
    path: '/dailyPay/risk/commonRemark',
    component: lazy('risk/commonRemark'),
    meta: {
      title: '说明',
    }
  },
  // -----------发放记录------------ //
  {
    path: '/dailyPay/grantDetails/:customerNo/:merchantName',
    name: 'dailyPayGrantDetails',
    component: lazy('detail/details'),
    meta: {
      title: '发放记录',
      keepAlive: true,
    }
  },
];
